"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M11.9628 2.50225C13.3024 1.10257 15.523 1.05388 16.9227 2.3935C18.3224 3.73312 18.3711 5.95376 17.0314 7.35344",
      stroke: "currentColor",
      strokeWidth: "0.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M3.23033 11.6258C4.56995 10.2261 6.79059 10.1774 8.19027 11.517C9.58995 12.8567 9.63863 15.0773 8.29902 16.477",
      stroke: "currentColor",
      strokeWidth: "0.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M4.19908 10.6121C5.5387 9.21243 7.75934 9.16374 9.15902 10.5034C10.5587 11.843 10.6074 14.0636 9.26777 15.4633",
      stroke: "currentColor",
      strokeWidth: "0.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.16978 9.5982C6.5094 8.19852 8.73004 8.14983 10.1297 9.48945C11.5294 10.8291 11.5781 13.0497 10.2385 14.4494",
      stroke: "currentColor",
      strokeWidth: "0.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M6.14049 8.58453C7.4801 7.18485 9.70074 7.13616 11.1004 8.47577C12.5001 9.81539 12.5488 12.036 11.2092 13.4357",
      stroke: "currentColor",
      strokeWidth: "0.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M9.0858 5.50787C10.4254 4.10819 12.6461 4.0595 14.0457 5.39911C15.4454 6.73873 15.4941 8.95937 14.1545 10.3591",
      stroke: "currentColor",
      strokeWidth: "0.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M7.10924 7.5711C8.44885 6.17142 10.6695 6.12273 12.0692 7.46235C13.4689 8.80196 13.5175 11.0226 12.1779 12.4223",
      stroke: "currentColor",
      strokeWidth: "0.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M10.0565 4.49395C11.3961 3.09427 13.6168 3.04558 15.0164 4.3852C16.4161 5.72482 16.4648 7.94546 15.1252 9.34513",
      stroke: "currentColor",
      strokeWidth: "0.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M8.07994 6.55718C9.41956 5.1575 11.6402 5.10881 13.0399 6.44843C14.4396 7.78805 14.4882 10.0087 13.1486 11.4084",
      stroke: "currentColor",
      strokeWidth: "0.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M11.0272 3.48003C12.3668 2.08035 14.5875 2.03166 15.9871 3.37128C17.3868 4.7109 17.4355 6.93154 16.0959 8.33122",
      stroke: "currentColor",
      strokeWidth: "0.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "4.55039",
      cy: "15.35",
      r: "3.55",
      stroke: "currentColor",
      strokeWidth: "1.2"
    })]
  });
};

exports.default = Icon;